import {client} from '../helpers/api';

export async function getClassrooms({kidIds, date}) {
  const kidIdsQs = kidIds
    ? kidIds.map((id) => `kid_id[]=${id}`).join('&') + '&'
    : '';
  const dateQs = `date=${date}`;

  const response = await client.get(`/api/classrooms?${kidIdsQs}${dateQs}`);

  if (response.data?.status) {
    return (
      response.data?.data.map(
        ({
          schedule_id: scheduleId,
          _subject_id: subjectId,
          _grade_id: gradeId,
          _teacher_id: teacherId,
          teacher_name: teacherName,
          teacher_image: teacherImage,
          week_day: weekDay,
          start_time: startTime,
          end_time: endTime,
          zoom_class_link: classLink,
          notes_id: notesId,
          class_date: classDate,
          video_link: videoLink,
          file_link: fileLink,
          student_name: studentName,
          schedule_canceled_id: scheduleCanceledId,
          cancel_reason: scheduleCancelReason,
          ...rest
        }) => ({
          ...rest,
          scheduleId,
          subjectId,
          gradeId,
          teacherId,
          weekDay,
          startTime,
          endTime,
          classLink,
          notesId,
          classDate,
          videoLink,
          fileLink,
          teacherName,
          teacherImage,
          studentName,
          scheduleCanceledId,
          scheduleCancelReason,
        }),
      ) || []
    );
  }
  throw response;
}

// {
//   "schedule_id": "015c7d56-3faf-430b-acdb-035be24c3643",
//   "_subject_id": "a450db0d-2f68-464c-b283-b444a87b4e43",
//   "_grade_id": "ef429895-17d0-42a0-bc64-70439eda149e",
//   "_teacher_id": "111904a1-c703-4ff8-9a0b-80bc455cfd24",
//   "week_day": "MON",
//   "start_time": "07:35 PM",
//   "end_time": "08:35 PM",
//   "zoom_class_link": null,
//   "date_created": "2021-01-16 01:31:40",
//   "date_modified": "2021-01-16 01:31:40",
//   "status": "active",
//   "is_deleted": 0,
//   "notes_id": "b28996bb-1a5f-4d00-a6a6-10b145fd7086",
//   "_schedule_id": "015c7d56-3faf-430b-acdb-035be24c3643",
//   "class_date": "2021-01-18",
//   "video_link": null,
//   "file_link": null
// }
